export default __webpack_public_path__ + "static/Practice_Area_Fallback-10275bbf88ee3b415b762d46621e099c.png";